import { defineComponent, ref, reactive } from 'vue'
import { px2rem } from '@/utils/common-function.js'
import s from './home.module.css'
import request from '@/utils/request.js'

// 区域头部
const SectionHeader = defineComponent({
  name: 'SectionHeader',
  props: { title: String, description: String },
  setup({ title, description }) {
    return () => (
      <div style="display: flex; align-items: center; justify-content: space-between; margin-bottom: 10px;">
        <div style="color: #7c1b00; font-weight: bold;">
          <div>{title}</div>
          <div style={`font-size: ${px2rem(20)}; font-style: italic;`}>{description}</div>
        </div>
        <img src="https://oss.huarendjk.com/img/2026-03-31/69cb717067b0b.png" style={{ width: px2rem(74), height: px2rem(74) }} />
      </div>
    )
  },
})
// 活动项
const ActivityItem = defineComponent({
  name: 'ActivityItem',
  props: { item: Object },
  setup({ item }) {
    return () => (
      <div
        className={s['activity-card']}
        style={{ height: px2rem(184), fontSize: px2rem(12), backgroundImage: `url(${item.img})` }}
      >
        <div className={s['activity-card_content']} style={{ height: px2rem(56) }}>
          <div style="flex: 1; margin-right: 10px; overflow: hidden;">
            <div className="ellipsis">{item.title}</div>
            <div className="ellipsis" style="color: #888">
              {item.detail}
            </div>
          </div>
          <div className={s['activity-card_btn']} style={{ width: px2rem(64), height: px2rem(25) }}>
            查看详情
          </div>
        </div>
      </div>
    )
  },
})
// 活动
const Activity = defineComponent({
  name: 'Activity',
  props: { activityList: Array },
  setup(props) {
    return () => (
      <div className={s['section-card']}>
        <SectionHeader title="深圳狮子会正道服务队与您" description="一起携手公益" />
        {props.activityList.map(item => (
          <ActivityItem key={item.title} item={item} />
        ))}
      </div>
    )
  },
})
// 表单
const Form = defineComponent({
  name: 'Form',
  props: { activityList: Array, bankAccount: String },
  setup(props) {
    const form = reactive({
      title: '',
      total: '',
      name: '',
      tel: '',
    })
    const submitting = ref(false)

    function saveForm() {
      if (submitting.value) return
      submitting.value = true
      request
        .post('/szh_activity', form)
        .then(() => {
          alert('提交成功')
          // 清空表单数据
          form.title = ''
          form.total = ''
          form.name = ''
          form.tel = ''
        })
        .finally(() => {
          submitting.value = false
        })
    }

    function handleSubmit() {
      // 验证表单数据
      if (!form.title || !form.total || !form.name || !form.tel) {
        return alert('请填写完整信息')
      }
      // 验证金额是否为数字
      if (isNaN(form.total)) {
        return alert('金额必须为数字')
      }
      saveForm()
    }

    return () => (
      <div className={s['section-card']}>
        <SectionHeader title="深圳狮子会正道服务队与您" description="一起帮助他们" />
        <div style="padding: 0 10px;">
          <div>认捐项目</div>
          <select
            v-model={form.title}
            className={s['input']}
            style={{ marginTop: '8px', color: !form.title ? '#757575' : '#000' }}
          >
            <option value="" disabled selected>
              请选择认捐项目
            </option>
            {props.activityList.map(item => (
              <option key={item.title} value={item.title}>
                {item.title}
              </option>
            ))}
          </select>
          <div style="margin-top: 8px;">认捐金额</div>
          <input v-model={form.total} className={s['input']} placeholder="请输入金额" style="margin-top: 8px;" />
          <div style="margin-top: 8px;">联系人姓名</div>
          <input v-model={form.name} className={s['input']} placeholder="请输入联系人姓名" style="margin-top: 8px;" />
          <div style="margin-top: 8px;">联系人手机号</div>
          <input v-model={form.tel} className={s['input']} placeholder="请输入联系人手机号" style="margin-top: 8px;" />
          <div style="margin-top: 8px;">深圳狮子会正道服务队对公账号： {props.bankAccount}</div>
          <div className={s['submit-btn']} style={{ height: px2rem(40), lineHeight: px2rem(40) }} onClick={handleSubmit}>
            提交
          </div>
        </div>
      </div>
    )
  },
})
// 联系方式
const Contact = defineComponent({
  name: 'Contact',
  props: { leaderTel: String, chairTel: String },
  setup(props) {
    return () => (
      <div style="background: #fff; border-radius: 14px; padding: 20px; line-height: 1.5;">
        <div style="color: #7c1b00; font-weight: bold;">筹款委员会联系方式</div>
        <div>主席：{props.chairTel}</div>
        <div>队长：{props.leaderTel}</div>
      </div>
    )
  },
})

export default defineComponent({
  name: 'Home',
  setup() {
    // 活动数据
    const activityList = ref([])
    // 队长联系方式
    const leaderTel = ref('')
    // 主席联系方式
    const chairTel = ref('')
    // 对公账号
    const bankAccount = ref('')

    // 获取配置信息
    request.post('/szh_info').then(res => {
      activityList.value = res.activity_list
      leaderTel.value = res.leader_tel
      chairTel.value = res.president_tel
      bankAccount.value = res.card_no
    })

    return () => (
      <div>
        <img src="https://oss.huarendjk.com/img/2026-04-02/69cde5240d3c5.png" style="width: 100%;" />
        <div style="position: relative; top: -66px; padding: 0 14px;">
          <Activity activityList={activityList.value} />
          <Form activityList={activityList.value} bankAccount={bankAccount.value} />
          <Contact leaderTel={leaderTel.value} chairTel={chairTel.value} />
        </div>
      </div>
    )
  },
})
